// extracted by mini-css-extract-plugin
export var actionText = "_mq-4";
export var container = "_mq-0";
export var leftSection = "_mq-1";
export var rightSection = "_mq-2";
export var settingsButton = "_mq-6";
export var settingsIcon = "_mq-7";
export var shortcut = "_mq-5";
export var shortcutGroup = "_mq-3";